__turbopack_context__.v({
  "cards-con": "policyDetails-module-scss-module__lmyyNW__cards-con",
  "chevron": "policyDetails-module-scss-module__lmyyNW__chevron",
  "content-con": "policyDetails-module-scss-module__lmyyNW__content-con",
  "exp-con": "policyDetails-module-scss-module__lmyyNW__exp-con",
  "info-con": "policyDetails-module-scss-module__lmyyNW__info-con",
  "insurance-con": "policyDetails-module-scss-module__lmyyNW__insurance-con",
  "insurance-con-inner": "policyDetails-module-scss-module__lmyyNW__insurance-con-inner",
  "main-con": "policyDetails-module-scss-module__lmyyNW__main-con",
  "poilicies-con": "policyDetails-module-scss-module__lmyyNW__poilicies-con",
  "text-con": "policyDetails-module-scss-module__lmyyNW__text-con",
});
